import React, { useEffect, useState } from 'react';
import axiosInstance from '@utils/axiosInstance';
import { useDispatch } from 'react-redux';
import { setMessage } from '@store/messageSlice';

export default function TokenTimer() {
    const [remainingTime, setRemainingTime] = useState(0);
    const dispatch = useDispatch();

    const fetchTokenExpiration = async () => {
        try {
            const { data } = await axiosInstance.get('/api/token/expiration');
            setRemainingTime(data.remainingMillis);
        } catch (error) {
            console.error("토큰 정보를 가져오는 중 에러 발생:", error);
            setRemainingTime(0);
        }
    };

    const onClickRefresh = async () => {

        try {
            const response = await axiosInstance.post('/api/token/refresh');

            const userInfoJSON = localStorage.getItem('userInfo');

            if (userInfoJSON) {
                const userInfo = JSON.parse(userInfoJSON);

                userInfo.token = response.data.token;

                localStorage.setItem('userInfo', JSON.stringify(userInfo));
            }

            fetchTokenExpiration();
            dispatch(
                setMessage({
                    message: "토큰이 성공적으로 연장되었습니다.",
                    type: 'info',
                })
            );
        } catch (error) {
            console.error('토큰 연장 실패:', error);
        }

    };

    useEffect(() => {
        fetchTokenExpiration();
        const intervalId = setInterval(() => {
            setRemainingTime(prevTime => (prevTime > 1000 ? prevTime - 1000 : 0));
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const formatTime = (millis) => {
        const totalSeconds = Math.floor(millis / 1000);
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };

    return (
        <div className="token-container">
            <span className="token-timer">{formatTime(remainingTime)}</span>
            <button className="token-refresh-btn" onClick={onClickRefresh}>
                <i className='bx bx-refresh'></i> 연장
            </button>
        </div>
    );
}